import CardBody from './CardBody';
import CardContainer from './CardContainer';
import CardHeader from './CardHeader';
import CardImage from './CardImage';
import CardLabel from './CardLabel';
import CardProduct from './CardProduct';
import CardSubtitle from './CardSubtitle';
import CardTitle from './CardTitle';
import CardTool from './CardTool';

export interface CardProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export default Object.assign(
  ({ children, className = '', ...rest }: CardProps) => {
    return (
      <div className={`card ${className}`} {...rest}>
        {children}
      </div>
    );
  },
  {
    Header: CardHeader,
    Title: CardTitle,
    Subtitle: CardSubtitle,
    Body: CardBody,
    Label: CardLabel,
    Image: CardImage,
    Container: CardContainer,
    Tool: CardTool,
    Product: CardProduct,
  },
);
